<template>
  <div class="error-page">
    对不起，你输入的地址不存在，{{timeCounter}}秒后跳转到首页
  </div>
</template>

<script>
export default {
    name: 'error',
    data () {
        return {
            timeCounter:5,
            count:null
        };
    },
    methods:{
        decount(){
            // let that=this;
            this.count=setInterval(() => {
                if (this.timeCounter === 0){
                    this.$router.push({path:'/'});
                } else {
                    this.timeCounter=this.timeCounter-1;
                }
            }, 1000);
        }
    },
    mounted(){
        this.decount();
    },
    beforeDestroy(){
        clearInterval(this.count);
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/404Page.vue